import useSWR from 'swr';

import apiRequest from '@/services/apiRequest';
import { getCoreApi } from '@/utility/getCoreApi';

export const useReferralCodeEligibility = (code?: string) => {
  return useSWR(code ? `${getCoreApi()}/referrals/${code}/eligibility` : null, url =>
    apiRequest<{ eligible?: boolean }>({ url }, true, true)
      .then(response => response.data)
      .catch(error => {
        // If the user is not logged in, they are eligible to use the referral code
        if (error?.status === 401) return { eligible: true };

        throw error;
      }),
  );
};
